import React from 'react';
import { MediaQueueTile } from '@cube3/ui/src/Prefabs/MediaQueue/MediaQueueTile';
import Thumbnail from '@cube3/ui/src/thumbnails/Thumbnail';
import Time from '@cube3/cubicle/src/core/utility/Time';
import { LibraryItemOverlay } from '@cube3/ui/src/library/LibraryItemOverlay';

import fileImage from '@cube3/ui/src/assets/images/Library/file.svg?url';

import { Shimmer } from '@cube3/cubicle/src/core/atoms/Loader/Shimmer';

import { useUploadStatus } from '../../hooks/useUploadStatus';
import { UploadBreadcrumbs } from '../UploadBreadcrumbs';
import { useUploadActions } from '../../hooks/useUploadActions';

export const UploadQueueListItemAssetProcessed = ({ asset, upload }) => {
  const { status, label, progress } = useUploadStatus(undefined, asset);

  const { onClickRemoveUpload } = useUploadActions({
    upload,
    asset
  });

  return (
    <li style={{ listStyle: 'none' }}>
      <MediaQueueTile
        thumb={
          <LibraryItemOverlay
            back={
              <Thumbnail
                src={asset?.display_image || fileImage}
                cover={false}
                ratio="sixteenToNine"
              />
            }
          />
        }
        title={asset?.display_name || 'loading'}
        contextRow={<UploadBreadcrumbs asset={asset} />}
        timestampRow={
          (asset && (
            <span>
              Last activity <Time date={asset?.updated_at} />
            </span>
          )) || <Shimmer width={120} height={20} />
        }
        status={status}
        statusLabel={label}
        statusProgress={progress}
        onCloseClick={
          (status === 'failed' || status === 'success') && onClickRemoveUpload
        }
      />
    </li>
  );
};
